module.exports = __webpack_public_path__ + "static/headerRightBg375-c2f77633ccb6c7d5e15ee3b2345d98e4.png";